(function () {
  var VAR = { black: '44605497311319', grey: '44605503144023', pink: '44605503176791' };
  var NAME = { black: 'Black', grey: 'Grey', pink: 'Pink' };
  var KEYS = ['black', 'grey', 'pink'];
  var QTY = [1, 2, 3];
  var showPhoto = function () {};

  var sws = [].slice.call(document.querySelectorAll('.ef-hero-swatch'));
  var DOT = {};
  sws.forEach(function (s, i) { if (KEYS[i]) DOT[KEYS[i]] = getComputedStyle(s).backgroundColor; });

  var st = document.createElement('style');
  st.textContent = '.ef-root .ef-hero-bundle{cursor:pointer;}'
    + '.ef-root .ef-hero-bundle:not(.ef-hero-bundle-selected) .ef-hero-bundle-extras{display:none !important;}'
    + '.ef-root .ef-hero-bundle-extras{flex-direction:column !important;align-items:stretch !important;}'
    + '.ef-root .ef-hero-bundle-row{display:flex;align-items:center;gap:12px;}'
    + '.ef-root .ef-hero-bundle-select{position:relative !important;flex:1 !important;}'
    + '.ef-root .ef-hero-bundle-select select{position:absolute;inset:0;width:100%;height:100%;opacity:0;cursor:pointer;font-size:16px;}'
    + '.ef-root .ef-hero-bundle-dot{width:14px;height:14px;border-radius:50%;border:1px solid #c9b8ae;display:inline-block;margin-right:8px;vertical-align:-2px;}'
    + '.ef-root .ef-hero-swatch.is-on{box-shadow:0 0 0 2px #612106;}'
    + '.ef-root .ef-hero-accordion-header{cursor:pointer;}';
  document.head.appendChild(st);

  var bundles = [].slice.call(document.querySelectorAll('.ef-hero-bundle'));
  var label = document.querySelector('.ef-hero-color-label');
  var colors = QTY.map(function (n) { var a = []; for (var k = 0; k < n; k++) a.push('black'); return a; });
  var cur = bundles.map(function (b) { return b.classList.contains('ef-hero-bundle-selected'); }).indexOf(true);
  if (cur < 0) cur = 0;

  function syncHeader() {
    var c = colors[cur];
    var same = c.every(function (x) { return x === c[0]; });
    sws.forEach(function (s, i) { s.classList.toggle('is-on', same && KEYS[i] === c[0]); });    if (label) label.textContent = 'Color, ' + (same ? NAME[c[0]] : c.map(function (x) { return NAME[x]; }).join(' + '));
  }

  function setBuyLinks() {
    syncHeader();
    var cnt = {};
    colors[cur].forEach(function (c) { cnt[c] = (cnt[c] || 0) + 1; });
    var parts = Object.keys(cnt).map(function (c) { return VAR[c] + ':' + cnt[c]; });
    [].slice.call(document.querySelectorAll('a[data-js-buy]')).forEach(function (a) {
      a.setAttribute('href', '/cart/' + parts.join(','));
      a.removeAttribute('target');
    });
  }

  function buildOptions() {
    bundles.forEach(function (b, i) {
      var old = b.querySelector('.ef-hero-bundle-extras');
      if (old) old.parentNode.removeChild(old);
      var box = document.createElement('div');
      box.className = 'ef-hero-bundle-extras';
      colors[i].forEach(function (c, r) {
        var row = document.createElement('div');
        row.className = 'ef-hero-bundle-row';
        var num = document.createElement('span');
        num.className = 'ef-hero-bundle-numlabel';
        num.textContent = '#' + (r + 1);
        var wrap = document.createElement('div');
        wrap.className = 'ef-hero-bundle-select';
        var txt = document.createElement('span');
        var dot = document.createElement('i');
        dot.className = 'ef-hero-bundle-dot';
        dot.style.background = DOT[c];
        var name = document.createTextNode(NAME[c]);
        txt.appendChild(dot); txt.appendChild(name);
        var arrow = document.createElement('span');
        arrow.textContent = '▾';
        var sel = document.createElement('select');
        sel.setAttribute('aria-label', 'Color for fan ' + (r + 1));
        KEYS.forEach(function (k) {
          var o = document.createElement('option');
          o.value = k; o.textContent = NAME[k]; if (k === c) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function () {
          colors[i][r] = sel.value;
          name.nodeValue = NAME[sel.value];
          dot.style.background = DOT[sel.value];
          setBuyLinks();
          showPhoto(KEYS.indexOf(sel.value));
        });
        wrap.appendChild(txt); wrap.appendChild(arrow); wrap.appendChild(sel);
        row.appendChild(num); row.appendChild(wrap);
        box.appendChild(row);
      });
      b.appendChild(box);
    });
  }

  function pick(i) {
    cur = i;
    bundles.forEach(function (b, k) {
      b.classList.toggle('ef-hero-bundle-selected', k === i);
      var r = b.querySelector('.ef-hero-radio');
      if (r) r.classList.toggle('ef-hero-radio-filled', k === i);
    });
    setBuyLinks();
  }
  bundles.forEach(function (b, i) {
    b.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.ef-hero-bundle-extras')) return;
      pick(i);
    });
  });
  buildOptions();
  pick(cur);

  /* colour swatches under the title: set every fan to that colour */
  sws.forEach(function (sw, i) {
    if (!KEYS[i]) return;
    sw.addEventListener('click', function () {
      colors = QTY.map(function (n) { var a = []; for (var k = 0; k < n; k++) a.push(KEYS[i]); return a; });
      buildOptions();
      pick(cur);
      showPhoto(i);
    });
  });

  /* gallery: thumbnails and arrows switch the main photo */
  (function () {
    var main = document.querySelector('.ef-hero-main-image');
    var thumbs = [].slice.call(document.querySelectorAll('.ef-hero-thumb'));
    if (!main || !thumbs.length) return;
    var idx = 0;
    function show(i) {
      idx = (i + thumbs.length) % thumbs.length;
      main.style.setProperty('background-image', getComputedStyle(thumbs[idx]).backgroundImage, 'important');
      main.style.setProperty('background-size', 'cover', 'important');
      main.style.setProperty('background-position', 'center', 'important');
      thumbs.forEach(function (t, k) { t.classList.toggle('ef-hero-thumb-active', k === idx); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    showPhoto = function (i) { if (thumbs[i]) show(i); };
    var l =document.querySelector('.ef-hero-chevron-left'), r = document.querySelector('.ef-hero-chevron-right');
    if (l) l.addEventListener('click', function () { show(idx - 1); });
    if (r) r.addEventListener('click', function () { show(idx + 1); });
    show(0);
  })();

  /* delivery timeline: real dates from today (processing 1-3 business days, US delivery 7-15 business days) */
  (function () {
    var cells = [].slice.call(document.querySelectorAll('.ef-hero-timeline-date'));
    if (cells.length < 3) return;
    function addBiz(d, n) {
      var x = new Date(d.getTime());
      while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
      return x;
    }
    function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    function range(a, b) { return fmt(addBiz(now, a)) + ' - ' + fmt(addBiz(now, b)); }
    var now = new Date();
    cells[0].textContent = fmt(now);
    cells[1].textContent = range(1, 3);
    cells[2].textContent = range(8, 18);
  })();

  /* accordions open and close */
  [].slice.call(document.querySelectorAll('.ef-hero-accordion')).forEach(function (acc) {
    var head = acc.querySelector('.ef-hero-accordion-header');
    var body = acc.querySelector('.ef-hero-accordion-body');
    var chev = acc.querySelector('.ef-hero-accordion-chevron');
    if (!head || !body) return;
    head.addEventListener('click', function () {
      var hidden = body.style.getPropertyValue('display') === 'none';
      if (hidden) body.style.removeProperty('display'); else body.style.setProperty('display', 'none', 'important');
      if (chev) chev.textContent = hidden ? '▴' : '▾';
    });
  });

  /* footer: use the store's homepage footer (isolated frame, no scripts / tracking) */
  (function () {
    var anchor = document.querySelector('.ef-root');
    if (!anchor) return;
    fetch('/', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var all = [].slice.call(doc.querySelectorAll('.shopify-section-group-footer-group'));
      if (!all.length) return;
      var grp = doc.createElement('div');
      grp.className = 'tb-footer-wrap';
      [].slice.call(doc.querySelectorAll('script,noscript,iframe')).forEach(function (e) { e.parentNode.removeChild(e); });
      var base = doc.createElement('base');
      base.setAttribute('href', location.origin + '/');
      base.setAttribute('target', '_top');
      doc.head.insertBefore(base, doc.head.firstChild);
      var stl = doc.createElement('style');
      stl.textContent = 'html,body{margin:0 !important;padding:0 !important;overflow:hidden !important}';
      doc.head.appendChild(stl);
      doc.body.innerHTML = '';
      all.forEach(function (e) { grp.appendChild(e); });
      doc.body.appendChild(grp);
      var frame = document.createElement('iframe');
      frame.setAttribute('title', 'Footer');
      frame.setAttribute('scrolling', 'no');
      frame.style.cssText = 'display:block;width:100%;border:0;height:300px';
      frame.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
      function fit() {
        try {
          var g = frame.contentDocument.querySelector('.tb-footer-wrap');
          if (g) frame.style.height = Math.ceil(g.getBoundingClientRect().height) + 'px';
        } catch (e) {}
      }
      frame.addEventListener('load', function () {
        fit();
        try { new ResizeObserver(fit).observe(frame.contentDocument.querySelector('.tb-footer-wrap')); } catch (e) {}
        setTimeout(fit, 400); setTimeout(fit, 1500);
      });
      window.addEventListener('resize', fit);
      anchor.parentNode.insertBefore(frame, anchor.nextSibling);
    }).catch(function () {});
  })();
})();
